import PropTypes from 'prop-types';
import React from 'react'

import { setPassword } from '~/actions/profiles'


export default class extends React.Component {
    static contextTypes = {
		store: PropTypes.object
	};

    state = {
        editPasswords: ''
    };

    addPassword = () => {
		this.setState({
			editPasswords: 'new'
		})
	};

    changePassword = () => {
		this.setState({
			editPasswords: 'change'
		})
	};

    updatePassword = () => {
		var does_password_exist = this.state.editPasswords === 'change',
			old_password = does_password_exist ? this.refs.current_password.value : false,
			new_password = this.refs.new_password.value,
			c_password = this.refs.new_password_repeat.value;
		this.context.store.dispatch( setPassword( new_password, c_password, old_password ) )
		this.closePasswords();
	};

    closePasswords = () => {
		this.setState({
			editPasswords: ''
		})
	};

    render() {

		return (

			<div className="row mbot10">
				<div className="col-sm-4">
					<p>Password</p>
				</div>
				<div className="col-sm-8">
					{ this.state.editPasswords
						? <div className="password-form">
							{ this.state.editPasswords == 'change' && 
								<div>
									<label className="text-mid-gray" for="current_password">Current</label>
									<input type="password" className="border-light-gray" ref="current_password" name="current_password" />
								</div>
							}
							<div>
								<label className="text-dark-gray" for="new_password">New</label>
								<input type="password" className="border-light-gray" ref="new_password" name="new_password" />
							</div>
							<div>
								<label className="text-dark-gray" for="new_password_repeat">Repeat</label>
								<input type="password" className="border-light-gray" ref="new_password_repeat" name="new_password_repeat" />
							</div>
							<button className="btn btn-primary" onClick={ this.updatePassword }>
								<i className="icon-check text-white"></i>
							</button>
							<button className="btn btn-secondary" onClick={ this.closePasswords }>
								<i className="icon-cross text-white"></i>
							</button>
						</div>
						: this.props.password_set
							? <p>******** <span onClick={this.changePassword} className="text-light-main clickable">Change password</span></p>
							: <p onClick={this.addPassword} className="text-mid-main clickable">Add a password to your account</p>
						
					}
				</div>
			</div>

		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Profile/components/Body/components/Settings/components/Passwords.jsx